// materials.ts — Patch 015.15 (Materials tracker).
//
// Backend: workers/core-os/src/routes/materials.ts (materials migration 0070).

import { request } from './request'

const pid = (id: string): string => encodeURIComponent(id)

export type MaterialStatus =
  | 'needed'
  | 'ordered'
  | 'in_transit'
  | 'delivered'
  | 'installed'

export interface MaterialRow {
  id: string
  project_id: string
  item_name: string
  vendor_name: string | null
  lead_time_days: number | null
  eta_date: string | null
  amount_cents: number | null
  status: MaterialStatus
  client_provided: number
  scs_line_id: string | null
  notes: string | null
  created_at: string
  updated_at: string | null
}

export interface MaterialListResponse {
  ok: true
  materials: MaterialRow[]
  count: number
}

export interface CreateMaterialInput {
  item_name: string
  vendor_name?: string
  lead_time_days?: number
  eta_date?: string
  amount_cents?: number
  status?: MaterialStatus
  client_provided?: boolean
  scs_line_id?: string
  notes?: string
}

export interface PatchMaterialInput {
  item_name?: string
  vendor_name?: string
  lead_time_days?: number
  eta_date?: string | null
  amount_cents?: number
  status?: MaterialStatus
  client_provided?: boolean
  notes?: string
  archived?: boolean
}

export const materialsApi = {
  list: (projectId: string, status?: MaterialStatus) =>
    request<MaterialListResponse>(
      `/api/projects/${pid(projectId)}/materials${status ? `?status=${status}` : ''}`,
    ),
  create: (projectId: string, body: CreateMaterialInput) =>
    request<{ ok: true; id: string; request_id: string }>(
      `/api/projects/${pid(projectId)}/materials`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (projectId: string, id: string, body: PatchMaterialInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${pid(projectId)}/materials/${pid(id)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
